import React from "react";
import { toast } from "sonner";
import { Wallet, CreditCard, Clock } from "@phosphor-icons/react";
import { custApi, formatErr } from "../../lib/customerApi";
import { openRazorpay } from "../../lib/razorpay";

// Charges a health booking via wallet or Razorpay. Returns true when paid.
export async function payHealthBooking(booking, method) {
  const base = `/me/health/bookings/${booking.id}/pay`;
  try {
    if (method === "wallet") {
      await custApi.post(`${base}/wallet`);
      toast.success(`Paid ₹${booking.amount} from wallet`);
      return true;
    }
    if (method === "razorpay") {
      const { data: o } = await custApi.post(`${base}/razorpay-order`);
      if (o.already_paid) return true;
      const res = await openRazorpay({ ...o, name: "Rescigo Health",
        description: `Booking ${booking.no}`, theme: "#DC2626" });
      await custApi.post(`${base}/razorpay-verify`, res);
      toast.success("Payment successful");
      return true;
    }
  } catch (e) {
    toast.error(`${formatErr(e)} — you can pay later from My bookings`);
  }
  return false;
}

const OPTIONS = [
  { k: "wallet", label: "Wallet", sub: "Rescigo balance", Icon: Wallet },
  { k: "razorpay", label: "Razorpay", sub: "UPI · Card · Netbanking", Icon: CreditCard },
  { k: "later", label: "Pay later", sub: "Pay from My bookings", Icon: Clock },
];

export function PayMethodPicker({ value, onChange, testPrefix }) {
  return (
    <div className="mt-4" data-testid={`${testPrefix}-pay-method`}>
      <div className="text-[10px] uppercase tracking-[0.22em] text-[#8A8780] font-semibold mb-2">Payment method</div>
      <div className="grid grid-cols-3 gap-2 max-w-md">
        {OPTIONS.map(o => (
          <button key={o.k} type="button" onClick={() => onChange(o.k)} data-testid={`${testPrefix}-pay-${o.k}`}
                  className={`p-2.5 rounded-lg border text-left text-xs transition-colors ${value === o.k ? "border-[#DC2626] bg-[#FDECEC]" : "border-[#E5E2D9] bg-white"}`}>
            <o.Icon size={14} className="text-[#DC2626]"/>
            <div className="font-medium mt-1">{o.label}</div>
            <div className="text-[10px] text-[#8A8780]">{o.sub}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
